const pizzaData = [
  {
    name: "Pizza Margarita",
    qty: "2",
    price: "30",
    time: "18:30",
    customer: "John",
  },
  {
    name: "Pepperoni Pizza",
    qty: "1",
    price: "25",
    time: "19:00",
    customer: "Alice",
  },
  {
    name: "BBQ Chicken Pizza",
    qty: "3",
    price: "35",
    time: "19:15",
    customer: "Michael",
  },
  {
    name: "Veggie Pizza",
    qty: "1",
    price: "28",
    time: "20:00",
    customer: "Sophia",
  },
  {
    name: "Hawaiian Pizza",
    qty: "2",
    price: "32",
    time: "20:30",
    customer: "David",
  },
  {
    name: "Meat Lover's Pizza",
    qty: "1",
    price: "38",
    time: "21:00",
    customer: "Emma",
  },
  {
    name: "Cheese Pizza",
    qty: "4",
    price: "22",
    time: "21:30",
    customer: "Olivia",
  },
  {
    name: "Buffalo Chicken Pizza",
    qty: "2",
    price: "36",
    time: "22:00",
    customer: "James",
  },
  {
    name: "Supreme Pizza",
    qty: "3",
    price: "40",
    time: "22:30",
    customer: "Liam",
  },
  {
    name: "Four Cheese Pizza",
    qty: "1",
    price: "34",
    time: "23:00",
    customer: "Ava",
  },
];

export { pizzaData };
